import React, { useContext } from "react";
import { Container } from "./question.styles";
import Title from "../Title/Title";
import Body from "../Body/Body";
import Footer from "../Footer/Footer";
import SurveyContext from "../../contexts/SurveyContext";
import { FINISH } from "../../constants/questionTypes";
import CurrentQuestionContext from "../../contexts/CurrentQuestionContext";

//TODO: CHANGE TO FINISH
const Question = ({ setPrivacyShow }) => {
  const questionType = useContext(CurrentQuestionContext).question.type;
  const isAlreadyAnswered = useContext(SurveyContext).isAlreadyAnswered;

  if (isAlreadyAnswered) {
    return (
      <Container>
        <Title />
        <Body />
      </Container>
    );
  } else {
    return (
      <Container isFinish={questionType === "FINISH"}>
        <Title />
        <Body />
        <Footer setPrivacyShow={setPrivacyShow} />
      </Container>
    );
  }
};

export default Question;
